var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['toolbar-button', _vm.isH5 ? 'toolbar-button-h5' : '', _vm.isClicked ? 'end-conversation-button-clicked' : ''],
    on: {
      "click": _vm.onClick
    }
  }, [_vm.props.icon ? _c('Icon', {
    staticClass: "toolbar-button-icon",
    attrs: {
      "file": _vm.props.icon,
      "width": "14px",
      "height": "14px"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "toolbar-button-text"
  }, [_vm._v(" " + _vm._s(_vm.props.title || _vm.TUITranslateService.t('AIDesk.结束会话')) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }